export default {"src":"/_next/static/media/FDX.b2d89746.svg","height":18,"width":18};